import React, { useEffect, useState, useContext } from 'react';
import { Link } from 'react-router-dom';
import { toast } from 'react-toastify';
import VisibilityIcon from '@mui/icons-material/Visibility';
import ToggleOffIcon from '@mui/icons-material/ToggleOff';
import ToggleOnIcon from '@mui/icons-material/ToggleOn';
import { DataGrid, GridToolbar } from "@mui/x-data-grid";
import { AuthContext } from '../../context/authContext';
import { getEducations, logoutUser, toggleEducations, togglePost } from '../../utilities/sendRequest';
import { dateIndo, dateTimeIndo, dateTimeIndoNew } from '../../utilities/helper';

const Educations = () => {
    const { dispatch } = useContext(AuthContext)
    const [datas, setDatas] = useState([])
    const [fetchMore, setFetchMore] = useState(true)

    useEffect(() => {
        fetchEducations()
        setFetchMore(false)
        
        // eslint-disable-next-line
    }, [fetchMore])

    const fetchEducations = async () => {
        getEducations().then((res) => {
            setDatas(
                res.payload.sort((p1, p2) => {
                    return new Date(p2.createdAt) - new Date(p1.createdAt)
                })
            )
        }).catch((error) => {
            toast.error(error.message, {
                position: toast.POSITION.TOP_RIGHT,
                autoClose: 3000
            });

            if (error.response.status === 401) {
                setTimeout(() => {
                    logoutUser(dispatch)
                }, 3500)
            }
        })
    }

    const handleToggle = (paramsSlug) => {
        toggleEducations(paramsSlug).then((res) => {
            toast.success(res.message, {
                position: toast.POSITION.TOP_RIGHT,
                autoClose: 3000
            });
            setFetchMore(true)
        }).catch((error) => {
            toast.error(error.response.data.message, {
                position: toast.POSITION.TOP_RIGHT,
                autoClose: 3000
            });

            if (error.response.status === 401) {
                setTimeout(() => {
                    logoutUser(dispatch)
                }, 3500)
            }
        })
    }

    const columns = [
        { 
            field: 'title', 
            headerName: 'Title',
            width: 350, 
            renderCell: (params) => {
                return (
                    <div className='flex justify-center items-center font-ssp'>
                        {params.row.title}
                    </div>
                )
            } 
        },
        { 
            field: 'publish_date', 
            headerName: 'Publish', 
            width: 200, 
            renderCell: (params) => {
                return (
                    <div className="font-ssp">
                        {dateIndo(params.row.publish_date)} {params.row.publish_time}
                    </div>
                )
            } 
        },
        {
            field: 'is_public',
            headerName: 'Class',
            width: 150,
            renderCell: (params) => {
                return (
                    <div className="font-ssp capitalize">
                        {params.row.is_public ? "Public Class" : "Private Class"}
                    </div>
                )
            } 
        },
        {
            field: 'is_restream',
            headerName: 'Training',
            width: 150,
            renderCell: (params) => {
                return (
                    <div className="font-ssp capitalize">
                        {params.row.is_restream ? "Re-Play" : "Live"}
                    </div>
                )
            } 
        },
        {
            field: 'status',
            headerName: 'Status',
            width: 150,
            renderCell: (params) => {
                return (
                    <div className="font-ssp">
                        {params.row.is_active
                            ? <span className="px-2 py-1 bg-green-400 rounded-full text-white uppercase">active</span>
                            : <span className="px-2 py-1 bg-red-400 rounded-full text-white uppercase">inactive</span>
                        }
                    </div>
                )
            } 
        },
        {
            field: 'action',
            headerName: 'Action',
            width: 150,
            renderCell: (params) => {
                return (
                    <div className='w-full flex flex-row gap-3 items-center'>
                        <Link to={"/educations/" + params.row.slug}>
                            <VisibilityIcon fontSize='medium' className="text-slate-400 hover:text-slate-500 cursor-pointer"/>
                        </Link>
                        {params.row.is_active
                            ? <ToggleOnIcon className="text-green-400 hover:text-green-500 cursor-pointer" onClick={() => handleToggle(params.row.slug)}/>
                            : <ToggleOffIcon className="text-gray-400 hover:text-gray-500 cursor-pointer" onClick={() => handleToggle(params.row.slug)}/>
                        }
                    </div>
                )
            }
        },
    ]

    return (
        <div className={`min-h-[calc(100vh-4rem)] flex flex-col`}>
            {/* header  */}
            <div className="my-5 mb-5 mx-7 md:mx-5 flex flex-col md:flex-row justify-between">
                <h1 className='font-ssp font-bold text-2xl md:text-3xl'>Educations</h1>
                <Link to={'/educations/add'} className="px-5 py-2.5 mr-3 mt-3 md:mt-1 bg-blue-400 hover:bg-blue-500 rounded-lg text-sm font-medium flex self-start md:self-end cursor-pointer">
                    <span className='text-sm text-white font-ssp'>Add New</span>
                </Link>
            </div>
            {/* content  */}
            <div className="my-5 mb-5 mx-7 md:mx-5 flex">
                <div className="p-2 w-full flex bg-white drop-shadow-lg rounded-md">
                    <DataGrid
                        autoHeight {...datas}
                        rows={datas}
                        columns={columns}
                        pageSize={10}
                        getRowId={(row) => row.slug}
                        rowsPerPageOptions={[10]}
                        checkboxSelection
                        disableSelectionOnClick
                        components={{ Toolbar: GridToolbar, }}
                    />
                </div>
            </div>
        </div>
    )
}

export default Educations